import { render, staticRenderFns } from "./CampoUtilitario.vue?vue&type=template&id=7f162f38&scoped=true&"
import script from "./CampoUtilitario.vue?vue&type=script&lang=js&"
export * from "./CampoUtilitario.vue?vue&type=script&lang=js&"
import style0 from "./CampoUtilitario.vue?vue&type=style&index=0&id=7f162f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f162f38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCheckbox,VTextField,VTextarea})
